import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

export enum NetworkErrorStatus {
    UNAUTHORIZED = 401,
    FORBIDDEN = 403,
    NOT_FOUND = 404,
}

export default class TunzNetworkError extends Error {
    status: NetworkErrorStatus;

    config?: AxiosRequestConfig;

    request?: unknown;

    response?: AxiosResponse;

    traceId?: String;

    constructor(
        status: NetworkErrorStatus,
        message: string,
        originalError: AxiosError,
        traceId?: String,
    ) {
        super(message);
        this.status = status;
        this.request = originalError.request;
        this.response = originalError.response;
        this.config = originalError.config;
        this.traceId = traceId;
    }

    static isTunzNetworkError = (instance: unknown): instance is TunzNetworkError => {
        if (instance === null || instance === undefined) {
            return false;
        }
        if ((instance as TunzNetworkError).status && (instance as TunzNetworkError).config) {
            return true;
        }
        return false;
    };
}
